import { render, staticRenderFns } from "./New_Evaluation.vue?vue&type=template&id=b6f50fd4&"
import script from "./New_Evaluation.vue?vue&type=script&lang=js&"
export * from "./New_Evaluation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports